<template>
    <SearchObject
        :additional-params="{ ordering: 'order_id', ...additionalParams }"
        :allow-create="allowCreate"
        :autofocus="autofocus"
        :base-url="baseUrl"
        :create-label="$translate('create_a_order')"
        :disabled="disabled"
        :hide-details="hideDetails"
        :item-text="itemText"
        :label="label || $translate('select_order')"
        :readonly="readonly"
        :required="required"
        :value="value"
        @create="createOrder"
        @input="$emit('input', $event)"
        :error-messages="errorMessages"
            ref="search"
        :dense="dense"
        :outlined="outlined"
    >
        <template slot="item" slot-scope="{ item }">
            {{ itemText(item) }}
        </template>
    </SearchObject>
</template>

<script>
import EditCustomerOrder from "@/modals/customerorder";
import GlobalMixins from "@/mixins/global";

export default {
    mixins: [GlobalMixins],
    name: "SearchProvider",
    props: {
        // The base URL to fetch items from.
        baseUrl: {
            type: String,
            default: "/api/customerorders/",
        },
        // Additional GET parameters to include in the API request.
        additionalParams: {
            type: Object,
            default: () => ({}),
        },
        // Whether the component is disabled.
        disabled: {
            type: Boolean,
            default: false,
        },
        // v-model binding (selected item ID).
        value: {
            type: [String, Number],
            default: null,
        },
        // Label for the autocomplete.
        label: {
            type: String,
            default: "",
        },
        // Optional limit per request.
        limit: {
            type: Number,
            default: 20,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        allowCreate: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        errorMessages: {
            type: [String, Array],
            default: null,
        },
    },
    methods: {
        itemText(item) {
            if (item.seller_entity == this.current_entity_id) {
                return `${item.order_id} - ${item.buyer_name} - ${this.$utils.price(
                    item.total_amount_incl_vat
                )}`;
            }
            return `${item.order_id} - ${item.seller_name} - ${this.$utils.price(
                item.total_amount_incl_vat
            )}`;
        },
        focus() {
            this.$refs.search.focus();
        },
        async createOrder() {
            const result = await this.showModal({
                component: EditCustomerOrder,
                params: {
                    order: {},
                },
            });
            if (result) {
                this.$emit("input", result);
                this.$refs.search.update();
            } else {
                this.$refs.search.reset();
            }
        },
    },
    i18n: {
        messages: {
            en: {
                select_order: "Select a order",
                create_a_order: "Create a order",
            },
            fr: {
                select_order: "Sélectionnez un client",
                create_a_order: "Créer un client",
            },
        },
    },
};
</script>
